var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _rect8, _rect9, _rect10, _rect11, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComingSoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "9in",
    height: "9in",
    viewBox: "0 0 648 648",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5299d3;}.cls-2{fill:#54c0a8;}.cls-3{fill:#084064;}.cls-4{fill:#12699a;}.cls-5{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 131.6383,
    y: 36.6596,
    width: 45.9574,
    height: 593.8723,
    rx: 8.6809
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 464.0638,
    y: 36.6596,
    width: 45.9574,
    height: 593.8723,
    rx: 8.6809
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 17.3497,
    y: 615.4993,
    width: 608.6809,
    height: 17.8099,
    rx: 8.905
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 67.9043,
    y: 594.4758,
    width: 16.6409,
    height: 32.2082,
    rx: 8.3204,
    transform: "translate(454.0709 124.9356) rotate(45)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 47.8192,
    y: 594.4758,
    width: 16.6409,
    height: 32.2082,
    rx: 8.3204,
    transform: "translate(-415.3023 218.5315) rotate(-45)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 578.0582,
    y: 594.4758,
    width: 16.6409,
    height: 32.2082,
    rx: 8.3204,
    transform: "translate(603.4915 -235.7976) rotate(45)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 557.9731,
    y: 594.4758,
    width: 16.6409,
    height: 32.2082,
    rx: 8.3204,
    transform: "translate(-265.8817 579.2648) rotate(-45)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M314.1125,621.6262h0c-2.4457-3.89-.6538-9.417,4.0022-12.344l20.7512-12.8563c4.6561-2.927,10.4131-2.1461,12.8588,1.7443h0c2.4457,3.89.6539,9.417-4.0022,12.344l-20.7512,12.8563C322.3153,626.2975,316.5582,625.5166,314.1125,621.6262Z"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 299.0592,
    y: 590.4619,
    width: 17.0085,
    height: 40.8286,
    rx: 8.3204,
    transform: "translate(-341.8715 396.4018) rotate(-45)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 53,
    y: 86.3191,
    width: 534.1277,
    height: 250.2827,
    rx: 15.3191
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 131.6383,
    y: 336.6018,
    width: 45.9574,
    height: 47.8024
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 464.0638,
    y: 336.6018,
    width: 45.9574,
    height: 47.8024
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M216.47,136.9448c9.9312-3.16,21.1035-6.6587,28.7778-10.0444l1.2413,6.5459a270.88,270.88,0,0,1-28.8907,9.7051Zm.564,14.2193c9.3672-2.9341,21.104-6.6582,28.7778-10.044l1.2417,6.5459c-8.0127,3.4981-19.6367,7.1094-28.8906,9.7051Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M229.2222,168.4312l8.4643-.5645,2.1441,55.75c.4511,12.0752,5.1914,15.4609,12.8652,15.9126,3.273,0,5.9814,1.58,5.9814,5.0781,0,2.2573-1.0156,5.1914-5.9814,5.1914-13.2036,0-20.5391-6.0942-21.2163-23.3608Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M246.6006,244.6074c0-2.2568,1.58-4.9653,5.8686-4.9653,12.4141,0,14.8965-7.4487,16.0254-17.2666l6.6582-.5645a35.166,35.166,0,0,0-.2256,3.8369c0,7.11,2.2569,13.8814,13.2037,13.9942,3.2729,0,5.9814,1.4668,5.9814,4.9653,0,2.2573-1.0156,5.1914-5.9814,5.1914-9.8184,0-15.1226-3.7241-17.3794-11.2851-2.9341,8.0122-9.2539,11.2851-18.3951,11.2851C247.8423,249.7988,246.6006,247.09,246.6006,244.6074ZM276.62,272.144c0,3.837-2.37,6.2071-5.8681,6.2071-3.3858,0-5.8682-2.37-5.8682-6.2071a5.7512,5.7512,0,0,1,5.8682-6.0942C274.25,266.05,276.62,268.5327,276.62,272.144Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M282.4873,244.4946c0-2.0312,1.2412-4.9653,5.6426-4.9653h2.2573c8.125,0,13.2036-.79,15.9121-2.5957a13.6682,13.6682,0,0,0,.1128-2.1445c-.3384-9.7051-4.5142-18.9595-8.6894-26.1822l8.2382-3.2724c3.4986,6.4326,8.0127,19.5234,8.0127,30.2446a26.9793,26.9793,0,0,1-1.2417,8.69c-3.16,2.7085-7.7866,5.53-22.9091,5.53H288.13C283.6157,249.7988,282.4873,246.8647,282.4873,244.4946Zm18.1694,27.5366a5.6322,5.6322,0,0,1-5.7558,5.981c-3.2725,0-5.7554-2.2568-5.7554-5.981a5.76,5.76,0,1,1,11.5112,0Zm15.1226,0c0,3.6114-2.37,5.981-5.7559,5.981s-5.53-2.2568-5.53-5.981c0-3.6113,2.1445-5.9814,5.53-5.9814S315.7793,268.42,315.7793,272.0312Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M356.5156,217.8613c2.37,4.74,4.5137,9.5923,6.2071,13.9937,2.9335,5.9814,6.5449,7.6743,11.5107,7.6743,3.2725,0,5.9814,1.58,5.9814,5.0781,0,2.2573-1.0156,5.1914-5.9814,5.1914-2.0313,0-5.5293-.2256-8.0127-1.9184-.1123,1.6928-.2256,3.8369-.4512,5.1914-2.9345,16.4765-16.2509,24.8276-26.7461,24.8276-5.53,0-12.3017-1.8056-16.3637-6.0942l1.0156-7.3355a28.3819,28.3819,0,0,0,15.2349,3.8369c9.3671,0,19.5234-8.2382,20.0878-21.1035-.5644-5.6426-6.6582-17.7177-10.7207-25.1665Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M374.2324,249.7988c-3.8369,0-5.7558-2.5957-5.7558-5.3042,0-2.4829,1.9189-4.9653,5.7558-4.9653h7.5606c11.5117,0,23.5869-1.8057,26.6338-3.273a18.3969,18.3969,0,0,0,.5644-3.8369c-21.1035.9029-28.7773-8.9155-28.7773-18.1694a20.0231,20.0231,0,0,1,5.8681-14.22,19.0825,19.0825,0,0,1,13.2041-6.0943c8.5762,0,17.9434,10.1568,17.9434,28.8907,0,5.53-.9024,14.6709-2.9346,19.6367-3.6113,2.5957-11.85,7.3354-33.5176,7.3354Zm8.4639-75.9507a5.6323,5.6323,0,0,1,5.7558-5.9814c3.3848,0,5.7549,2.37,5.7549,5.9814,0,3.7242-2.37,5.981-5.7549,5.981C385.1787,179.8291,382.6963,177.5723,382.6963,173.8481Zm26.8594,49.9942c.6767-7.5611-3.0469-20.9907-11.6241-20.9907a10.3553,10.3553,0,0,0-10.4951,10.27C387.4365,219.8926,395.5615,224.1812,409.5557,223.8423Zm-11.5118-49.9942c0-3.6113,2.1446-5.9814,5.53-5.9814s5.7559,2.37,5.7559,5.9814c0,3.7242-2.37,5.981-5.7559,5.981S398.0439,177.5723,398.0439,173.8481Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComingSoon);
export default __webpack_public_path__ + "static/media/comingSoon.e81866ccb3d76c2c5f776f26787cc30f.svg";
export { ForwardRef as ReactComponent };